export default {"src":"/_next/static/media/offcanvas-close.89923bd3.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};